import React, { ChangeEvent } from 'react';
import styled from 'styled-components';

const Container = styled.div`
    padding-left: 4px;
    padding-right: 4px;
`;

const TextArea = styled.textarea`
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.8);
    color: black;
    outline: none;
    padding: 4px;

    &:focus {
        border: 1px solid white;
    }
`;

const placeholderRegex: RegExp = /\${(.+?)}/g;

function getPlaceholdersFromText(text: string): string[] {
    return [...new Set([...text.matchAll(placeholderRegex)].map(m => m[1]))];
}

interface TextTemplateEditorProps {
    nodeState: Record<string, any>;
    setNodeState: (key: string, value: any) => void;
    nodeShape: {
        nodeInstanceOutPorts: Array<{ name: string; type: any }>;
    };
    updateShape: (shape: { inPorts: Array<{ name: string; type: any }>; outPorts: Array<{ name: string; type: any }> }) => void;
}

export const TextTemplateEditor: React.FC<TextTemplateEditorProps> = props => {
    const textValue = props.nodeState.textValue || '';

    const handleValueChange = (onChange: ChangeEvent<HTMLTextAreaElement>) => {
        const text = onChange.target.value;
        props.setNodeState('textValue', text);
    };

    return (
        <Container>
            <TextArea
                value={textValue}
                onChange={handleValueChange}
                rows={10}
                cols={30}
                placeholder="Enter your template using the pattern of ${PLACEHOLDER} to add pieces of text you want to replace with inputs from the graph. Example: Hi ${NAME} you are ${AGE} years old."
            />
        </Container>
    );
};
